import Agnes from '../../images/agnes.png';
import Akitekt from '../../images/akitekt.png';
import Realtor from '../../images/realtor.png';
import Provence from '../../images/provence.png';
import MyPortfolio from '../../images/john-portfolio.png';
import Fastech from '../../images/image.png'
import Miranda from '../../images/miranda.png'


const portfolioData = [

  {
    img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/fastech.png",
    title: "Fastech Solutions Website",
    description: "Crafted a sleek and modern website for an ISP client, using a vibrant light theme to effectively showcase their services and market their business.",
    description2: "The website features elegantly designed packages that present the client's offerings in a visually appealing and professional manner.",
    link: "https://fastechinternet.co.ke/",
    technologies: "HTML, CSS, JAVASCRIPT, BOOTSTRAP",
    dateCompleted: "March 2024",
},
{
  img: Realtor,
  title: "Realtors Real Estate Agency",
  description: "Crafted a comprehensive real estate platform designed to streamline property searches and enhance the home-buying experience.",
  description2: "The website's sleek interface, coupled with intuitive navigation, allows users to effortlessly explore property listings, making it an essential tool for both buyers and sellers.",
  link: "https://johnindakwa.github.io/realtorswebsite/",
  technologies: "HTML, CSS, JavaScript, Bootstrap",
  dateCompleted: "August 2024",
},
{
    img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/skyrich.png",
    title: "SkyRich Events Website",
    description: "Designed a visually stunning website for an event planning company, with a unique style and seamless transitions that captivate visitors from the homepage onwards.",
    description2: "The homepage features dynamic transitioning slides that set the tone for a vibrant user experience, leaving a lasting impression.",
    link: "https://johnindakwa.github.io/Colorful-SkyRich-Events/",
    technologies: "NEXTJS, CSS, JAVASCRIPT, TAILWIND CSS",
    dateCompleted: "March 2024",
},

{
  img: Fastech,
  title: "Fastech Solutions Ltd.",
  description: "Delivering exceptional IT solutions tailored to meet the unique needs of businesses. Fastech Solutions provides rapid-response IT support, ensuring seamless technology integration for clients.",
  description2: "From emergency troubleshooting to long-term strategic planning, Fastech Solutions is dedicated to helping businesses harness the power of technology with expertise and reliability.",
  link: "https://fastechsolutions.vercel.app",
  technologies: "REACTJS, CSS, JAVASCRIPT, TAILWIND CSS",
  dateCompleted: "March 2024",
},

{
  img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/ebony.png",
  title: "Ebony Beauty Salon",
  description: "Developed a chic and inviting website for a beauty salon, emphasizing elegance and sophistication to attract a fashion-forward clientele.",
  description2: "The website's design mirrors the salon's commitment to beauty and luxury, making it an essential tool for attracting style-conscious customers.",
  link: "https://johnindakwa.github.io/Ebony-Salon/",
  technologies: "VueJs, Tailwind CSS",
  dateCompleted: "June 2023",
},

{
  img: Miranda,
  title: "Monica Miranda Photography",
  description: "Monica Miranda is a wedding photographer and videographer, specializing in capturing authentic, joyful moments with elegance, artistry, and intention.",
  description2: "With a timeless, film-inspired style, Monica Miranda Photography creates stunning images that honor the heart of your wedding day—celebrating your unique love story and preserving every cherished detail for generations to come.",
  link: "https://monicamiranda.vercel.app",
  technologies: "REACTJS, CSS, JAVASCRIPT, TAILWIND CSS",
  dateCompleted: "March 2024",
},

{
    img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/autoassist.png",
    title: "AutoAssist IT Management System",
    description: "Developed as my final year degree project, this IT management system stood out for its advanced features and professional-grade execution, impressing my lecturers to the point of disbelief.",
    description2: "The system includes sophisticated visualizations and a user-friendly interface, showcasing my ability to deliver complex solutions with precision.",
    link: "/",
    technologies: "Laravel, Javascript, CSS, SQL",
    dateCompleted: "DEC 2023",
},
{
    img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/kemsa%20project.png",
    title: "Kemsa Inventory Management System",
    description: "Originally developed to refine my PHP skills, this inventory management system evolved into a robust solution that was later sold and successfully used as a degree project, earning top marks.",
    description2: "The system's efficiency and comprehensive features made it a valuable asset, demonstrating the practical application of my programming expertise.",
    link: "https://example.com/deep-learning-bitcoins",
    technologies: "PHP, HTML, JAVASCRIPT, GOOGLE MAPS, GOOGLE ANALYTICS, SQL",
    dateCompleted: "January 2024",
},
{
  img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/events.png",
  title: "Events Booking System",
  description: "Developed a versatile events booking platform that allows users to seamlessly browse, book, and manage event reservations with ease.",
  description2: "The system features a user-friendly interface and robust backend, ensuring a smooth experience for both event organizers and attendees.",
  link: "https://example.com/sql-tutorial",
  technologies: "PHP, HTML, JAVASCRIPT, SQLite",
  dateCompleted: "June 2023",
},
{
  img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/portfolio.png",
  title: "John Vianny React Portfolio",
  description: "Developed a sleek and modern portfolio for John Vianny, highlighting his professional achievements and skill set.",
  description2: "The portfolio features responsive design and seamless navigation, making it an effective tool for showcasing his work.",
  link: "https://johnindakwa.github.io/JOHNVIANNY/",
  technologies: "React, CSS, TAILWIND",
  dateCompleted: "March 2024",
},
{
  img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/owiphotography.png",
  title: "Owi Photography",
  description: "A classic photography website designed with passion and attention to detail, capturing the essence of the art through a visually compelling online presence.",
  description2: "The site showcases breathtaking galleries and portfolios, allowing the photographer's work to shine in an elegant, easy-to-navigate format.",
  link: "https://johnindakwa.github.io/Owi-Photography/",
  technologies: "HTML, CSS, JAVASCRIPT, BOOTSTRAP",
  dateCompleted: "March 2024",
},
{
  img: "https://johnindakwa.github.io/CODE-ARKITEKTS/Images/projects/sylar.png",
  title: "Sylar Insurance Corporate Website",
  description: "Developed a corporate website for Sylar Insurance, focused on delivering a professional and trustworthy online presence with a sleek design.",
  description2: "The website features comprehensive service information, client testimonials, and an intuitive user interface, reinforcing Sylar's brand identity.",
  link: "https://johnindakwa.github.io/Sylar-Insurance/",
  technologies: "React.js, Tailwind CSS",
  dateCompleted: "January 2024",
},
{
  img: MyPortfolio,
  title: "My Personal Portfolio Website",
  description: "This is the current website showcasing my skills and projects. Take a look and be the judge of my capabilities!",
  description2: "Integrated filtering features to help users easily navigate and explore my diverse range of projects and expertise.",
  link: "https://johhnindakwa.vercel.app/",
  technologies: "React.js, CSS, BOOTSTRAP",
  dateCompleted: "June 2023",
},
{
  img: Agnes,
  title: "Agnes React Portfolio",
  description: "Developed a sleek and modern portfolio for Agnes Wendi Okello, highlighting her professional achievements and skill set.",
  description2: "The portfolio features responsive design and seamless navigation, making it an effective tool for showcasing her work.",
  link: "https://agneswendi.vercel.app/",
  technologies: "React, CSS, TAILWIND",
  dateCompleted: "March 2024",
},
{
  img: Provence,
  title: "Provence Ecommerce System",
  description: "My favorite project ever, using classic, vintage designs that evoke a sense of nostalgia and warmth, perfect for an online store.",
  description2: "The system combines elegant aesthetics with modern e-commerce functionality, providing a unique shopping experience for customers.",
  link: "https://provence-shop.vercel.app/",
  technologies: "React.Js, Express, Node.JS, Mongodb, CSS",
  dateCompleted: "January 2024",
},
{
  img: Akitekt,
  title: "Code Arkitekts Agency Website",
  description: "Co-founded an IT agency and took the lead in creating a magical website that captures the essence of our creative and technical expertise.",
  description2: "The website serves as a digital hub for our services, showcasing our portfolio and attracting clients with its professional design.",
  link: "https://johnindakwa.github.io/CODE-ARKITEKTS/",
  technologies: "React.js, CSS, BOOTSTRAP",
  dateCompleted: "June 2023",
},

];



export { portfolioData};
